<template>
  <div class="outer-container flex justify-center bg-white dark:bg-slate-800" :class="{ '-mr-1': !isSpecialRoute }">
    <div v-if="filteredPreviousIcons.length > 0"
      class="flex flex-col items-center pt-6 pb-6 p-0 bg-white dark:bg-slate-800 sm:gap-3 md:gap-4 lg:gap-5 xl:gap-6">
      <div v-for="(icon, index) in filteredPreviousIcons" :key="index" class="tooltip-wrapper relative group "
      >
        <woot-button class="custom-button messenger" @click="openConversation(icon)"
        v-tooltip.left="{
  content: icon.inbox?.name || localStorage.getItem(`inbox-name-${icon.conversationId}`) || 'Unnamed Inbox',
  hideOnClick: true,
  offset:4,
}">
          <span v-if="
            icon.unreadCount > 0 &&
            !(icon.conversationId === currentConversationId || currentId === icon.conversationId)
          " class="unread-count">
            {{ icon.unreadCount }}
          </span>
          <fluent-icon :icon="icon.data" :viewBox="icon.viewBox" :size="'50'" :class="[
            icon.class,
            {
              'active-icon': icon.conversationId === currentConversationId||currentId === icon.conversationId,
            },
            ]" />
        </woot-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import InboxName from '../InboxName';

export default {
  components: {
    InboxName,
  },
  props: {
    conversationId: {
      type: [String, Number],
      required: true,
    },
    // messages: {
    //   type: [Array],
    //   required: true,
    // },
  },
  data() {
    return {
      inboxId: "",
      icons: [
        {
          name: 'Whatsapp',
          data: 'whatsapp',
          viewBox: '-4 -4 35.676 35.676',
          class: 'whatsapp',
        },
        {
          name: 'Facebook',
          data: 'facebook',
          viewBox: '-4 -4 35.676 35.676',
          class: 'insta-icon',
        },
        {
          name: 'Telegram',
          data: 'telegram',
          viewBox: '-4 -4 35.676 35.676',
          class: 'insta-icon',
        },

        {
          name: 'Email',
          data: 'mail',
          viewBox: '-5.6 -5 35.676 35.676',
          class: 'email',
        },
        {
          name: 'Messenger',
          data: 'messenger',
          viewBox: '-2 -2 35.676 35.676',
          class: 'insta-icon',
        },
        {
          name: 'Instagram',
          data: 'instagram',
          viewBox: '-10 -10 53 53',
          class: 'insta-icon',
        },
        {
          name: 'Twitter',
          data: 'twitter',
          viewBox: '0 0 512 512',
          class: 'insta-icon',
        },
        {
          name: 'WebWidget',
          data: 'web',
          viewBox: '-7 -10 53 53',
          class: 'insta-icon',
        },
        {
          name: 'Api',
          data: 'api',
          viewBox: '-3 -4 30 30',
          class: 'insta-icon',
        },
        {
          name: 'TwilioSms',
          data: 'sms',
          viewBox: '30 12 40 75',
          class: 'insta-icon',
        },
        {
          name: 'Line',
          data: 'line',
          viewBox: '-3 -3 30 30',
          class: 'insta-icon',
        },
        {
          name: 'JioEva',
          data: 'jio',
          viewBox: '-7 -6 39 35',
          class: 'insta-icon',
        },
        {
          name: 'TwilioCall',
          data: 'twilio',
          viewBox: '-7 -4 45 35',
          class: 'twilio',
        },
      ],
      currentConversationId: null,
      currentUrl: '',
      lastChat: {},
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'contactConversations/getUIFlags',
      currentChat: 'getSelectedChat',
    }),
    chatMetadata() {
      return this.chat.meta;
    },
    contactId() {
      return this.currentChat.meta?.sender?.id;
    },
    channelName() {
      return this.currentChat.meta?.channel?.split('::')[1];
    },
    filteredIcons() {
      return this.icons.filter(icon =>
        icon.name.toLowerCase().includes(this.channelName.toLowerCase())
      );
    },
    conversations() {
      return this.$store.getters['contactConversations/getContactConversation'](
        this.contactId
      );
    },
    inbox() {
      return this.$store.getters['inboxes/getInbox'](this.inboxId);
    },
    currentId() {
      const url = this.currentUrl.split('/');
      return Number(url[url.length - 1]);
    },
    previousConversations() {
      return this.conversations.sort((a, b) => b.timestamp - a.timestamp);
    },
    filteredPreviousIcons() {
      if(this.isSpecialRoute)
      {
        this.currentConversationId=this.conversationId;
      }
      return this.previousConversations
        .map(conversation => {
          const channel = conversation.meta?.channel?.split('::')[1];
          let iconName = channel;

          if (channel.toLowerCase() === 'facebookpage') {
            const type = conversation.additional_attributes?.type;
            iconName = type ? 'Instagram' : 'Messenger';
          }
          const icon = this.icons.find(
            icon => icon.name.toLowerCase() === iconName?.toLowerCase()
          );
          // Get inbox from store or fallback to conversation details
          const inboxFromStore = this.$store.getters['inboxes/getInbox'](conversation.inbox_id);
          const inboxObj = inboxFromStore || {
            name: conversation.inbox?.name || '',
            channel_type: conversation.channel_type,
            phone_number: conversation.phone_number,
          };
          if (icon && inboxObj) {
            // Store inbox name in localStorage
            localStorage.setItem(`inbox-name-${conversation.id}`, inboxObj.name || 'Unnamed Inbox');
            return {
              ...icon,
              conversationId: conversation.id,
              unreadCount: conversation.unread_count,
              inbox: inboxObj,
            };
          }

          return null;
        })
        .filter(Boolean); // Remove any null values, keeping duplicates
    },
    // displayedIcons() {
    //   // If filteredPreviousIcons has at least one icon, add "Concrete" to the end
    //   if (this.filteredPreviousIcons.length > 0 &&this.isSpecialRoute) {
    //     return [
    //       ...this.filteredPreviousIcons,
    //       {
    //         name: "Concrete",
    //         data: "concrete",
    //         viewBox: "0 0 41 41",
    //         class: "insta-icon",
    //       },
    //     ];
    //   }
    //   return this.filteredPreviousIcons;
    // },
    isSpecialRoute() {
      const { path, query } = this.$route;

      // Updated regex to match "/app/accounts/{id}/contacts/{contactId}"
      const specialRoutePattern = /^\/app\/accounts\/\d+\/contacts\/\d+$/;

      return specialRoutePattern.test(path) && !query.page; // Exclude routes with `page` query parameter
    },
  },
  watch: {
    $route(to) {
      this.currentUrl = to.fullPath;
      const conversationId = Number(this.currentUrl.split('/').pop());
      console.log("My COnversation",conversationId);
      this.currentConversationId = conversationId; // Update the active conversation ID
    },
    conversationId(newVal) {
      this.currentConversationId = newVal;
      const conversation = this.previousConversations.find(
        conv => conv.id === newVal
      );
      if (conversation) {
        this.inboxId = conversation.inbox_id;
        const channel = conversation.meta?.channel?.split('::')[1];
        this.currentChat.meta.channel = `channel::${channel}`;
      }
      this.$store.dispatch('contactConversations/get', this.contactId);
    },
  },
  mounted() {
    this.$store.dispatch('contactConversations/get', this.contactId);
    this.currentUrl = this.$route.fullPath;
    bus.$on('emit-data', data => {
      this.$store.dispatch('contactConversations/get', this.contactId);
    });
  },
  methods: {
    openConversation(Conversation) {
      console.log("Conversation",Conversation);
      this.currentConversationId =
        Conversation.conversationId;

      // Find the conversation's channel and update channelName
      const conversation = this.previousConversations.find(
        conv => conv.id === Conversation.conversationId
      );
      if (conversation) {
        this.$store.dispatch('contactConversations/get', this.contactId);
        const channel = conversation.meta?.channel?.split('::')[1];
        this.currentChat.meta.channel = `channel::${channel}`;
      }

      const id = this.currentUrl.split('/').pop();
      if (Number(id) !== Conversation.conversationId && !this.isSpecialRoute) {
        this.$router.push({
          name: 'inbox_conversation',
          params: { conversation_id: Conversation.conversationId },
        });
      } else if (this.isSpecialRoute) {
        bus.$emit('open-conversation', conversation);
      }
    },
  },
};
</script>


<style scoped>
.outer-container {
  width: 72px;
  height: 100%;
  padding: 1px;
  display: flex;
  justify-content: center;
  position: relative;
  /* margin: -10px; */
  /* background-color: white; */
  border: 1px solid #fbfbfb;
  margin-top: 0px;
  /* margin-right: -5px; */
}


.custom-button {
  background-color: #fff !important;
  padding:0px;
}

.custom-button >>> svg {
  width: 24px;
  height: 24px;
  color: #5a524e;
  transition: color 0.3s ease;
}

.inner-container:hover .custom-button {
  background-color: white;
}

.instagram >>> span {
  width: auto;
}

.messenger >>> span {
  width: auto;
}

.web >>> span {
  width: auto;
}

.twitter >>> span {
  width: auto;
}

.insta-icon,
.email,
.whatsapp,
.twilio {
  width: 40px !important;
  height: 40px !important;
}

.insta-icon:hover {
  color: blue;
  /* Alternatively, change the text or icon color if applicable */
}

.whatsapp:hover {
  color: #44ce4b;
}

.facebook:hover {
  color: blue;
}

.email:hover {
  color: red;
}
.twilio:hover {
  color: red;
}

.active-icon {
  color: #40518a !important;
  background-color: deepskyblue;
  border-radius: 5px;
  /* Change this to the desired active color */
}

.unread-count {
  position: absolute;
  right: 15px;
  background-color: #40518a;
  color: white;
  border-radius: 50%;
  padding: 2px 6px;
  font-size: 12px;
}
.tooltip-wrapper {
  position: relative;
  display: inline-block;
}
.tooltip-wrapper:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}


</style>